import type { FAQItem } from '../../seo/FAQSchema';

/** Hub-only FAQs — cluster-specific questions live on dedicated pages. */
export const logisticsServiceFaqs: FAQItem[] = [
  {
    question: 'What are logistics services in ecommerce?',
    answer:
      'Logistics services in ecommerce cover everything that happens after a customer places an order: warehousing the stock, picking and packing the item, arranging carrier dispatch and managing returns. A UK logistics provider like Pick Pack Pro (or packpro ecommerce) handles this end-to-end from one fulfilment centre in Milton Keynes.',
  },
  {
    question: 'Are you a midlands based fulfilment services provider?',
    answer:
      'Yes! We are centrally located in Milton Keynes, making us ideal midlands based fulfilment services. We easily cover surrounding areas, whether you need ecommerce warehousing northampton, ecommerce warehousing peterborough, or ecommerce warehousing nottingham. Our location offers fast courier cut-offs nationwide.',
  },
  {
    question: 'Do you offer pick and pack services uk wide?',
    answer:
      'Yes, our pick and pack services uk operations serve brands across the entire country. From our Milton Keynes base, we provide fast uk pick and pack dispatch that reaches customers the next day. If you need a reliable pick and pack service wolverhampton or anywhere else, our hub connects you.',
  },
  {
    question: 'What do your pick and pack warehouse services include?',
    answer:
      'Our pick and pack warehouse services include receiving your inventory into our WMS, securing it in ambient storage, and performing fast, barcode-verified pick and pack services for all DTC and B2B orders.',
  },
  {
    question: 'Which page should I use for pick and pack ecommerce orders?',
    answer:
      'Open Ecommerce fulfilment services UK for DTC pick, pack and carrier dispatch. Use Warehousing services if you mainly need storage first, or B2B fulfilment for wholesale and trade deliveries.',
  },
  {
    question: 'Do you still handle inbound freight and FBA FC drops?',
    answer:
      'Yes. Inbound collections, pallet moves and FBA inbound delivery are covered via our freight forwarder UK page and Amazon FBA shipments workflows — linked from this hub and available under the same Milton Keynes account.',
  },
  {
    question: 'Where do I get a quote?',
    answer:
      'Use Contact fulfilment services and tell us which lane you need (ecommerce, B2B, warehousing or freight). We price from your volumes and SKU profile — not a generic haulage tariff.',
  },
];

